const BACKEND_URL = (import.meta.env.VITE_BACKEND_URL ?? "").replace(/\/$/, "");
export class ApiError extends Error {
    status;
    code;
    detail;
    constructor(status, body) {
        const code = body?.error;
        super(code ?? `HTTP ${status}`);
        this.status = status;
        this.code = code;
        this.detail = body;
    }
}
export function apiUrl(path) {
    if (!BACKEND_URL)
        throw new Error("VITE_BACKEND_URL is not configured");
    return `${BACKEND_URL}${path.startsWith("/") ? path : `/${path}`}`;
}
export async function api(authFetch, path, init = {}) {
    const headers = new Headers(init.headers);
    if (init.body && !headers.has("Content-Type")) {
        headers.set("Content-Type", "application/json");
    }
    const response = await authFetch(apiUrl(path), { ...init, headers });
    const text = await response.text();
    const body = text ? safeJson(text) : null;
    if (!response.ok)
        throw new ApiError(response.status, body);
    return body;
}
function safeJson(text) {
    try {
        return JSON.parse(text);
    }
    catch {
        return text;
    }
}
